import { useContext } from "react";
import { TableRowContext } from "./TableRowContext";

/**
 * Indicates whether the current row has child content.
 * @returns True if the row has child content, otherwise false.
 */
export function useHasChildContent(): boolean | "loading" {
  const { hasChildContent } = useContext(TableRowContext);
  return hasChildContent;
}
